import React from 'react';

interface GuideIconProps {
  className?: string;
}

const GuideIcon: React.FC<GuideIconProps> = ({ className = '' }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 2h8a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1z" stroke="currentColor" strokeWidth="1" fill="none"/>
    <path d="M6 6h4M6 8h4M6 10h2" stroke="currentColor" strokeWidth="1"/>
  </svg>
);

export default GuideIcon;